/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./default.vue?vue&type=template&id=aa239a42"
import script from "./default.vue?vue&type=script&lang=ts&setup=true"
export * from "./default.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./default.vue?vue&type=style&index=0&id=aa239a42&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports